import React from "react";
import { useResponsiveBelowLg } from "src/hooks";
import { ContentSectionBelowLg } from "./ContentSection.belowLg";
import { ContentSection } from "./ContentSection";

export default function ContentSectionResponsive() {
  const isBelowLg = useResponsiveBelowLg();
  return isBelowLg ? <ContentSectionBelowLg /> : <ContentSection />;
}
